const SpecText = ({ className = "text-[#f64a45]", children }) => {
  return <span className={className}>{children}</span>;
};

export default SpecText;
